import BasketMobile from 'components/InlineBasket/BasketMobile/BasketMobile.ctrlr';
import { withBasketMobileProps } from 'viewModel/inlineBasket/basketMobile/withBasketMobileProps';

export default withBasketMobileProps(BasketMobile);
